// ============================================================
// REKLAM ALANI NUMARALARI (ALAN NO)
//
// Panelde reklam eklerken secilen "kategori", reklamin uygulamada NEREDE
// cikacagini belirler. Kategori adlari ("BERLIN IS REHBERI" gibi) tek basina
// nereye denk geldigini anlatmadigi icin her alana SABIT BIR NUMARA verildi.
//
// Numara nasil okunur:
//   Alan No 3  ->  "BERLIN IS REHBERI" kategorisi
//               ->  Anasayfada Is Rehberi kartinin altindaki reklam
//               ->  ve Firma Rehberi kategori ekranindaki reklam
//
// Numaralar uygulamada YUKARIDAN ASAGIYA gezilme sirasina gore verilmistir:
// once anasayfa (1-7), sonra bolum ici ekranlar (8-12), en son liste
// aralarindaki reklamlar (13-14).
//
// !!! NUMARALAR SABITTIR. Bir alan kaldirilsa bile numarasi baskasina
// verilmez, cunku musteriye/ajansa verilen fiyat listesi bu numaralara gore
// konusuluyor. Yeni alan eklenirse siradaki numara (15, 16, ...) verilir.
//
// MOBIL TARAFLA ESLESME: uygulamadaki karsiligi
// berlinesnafmobil/assets/Others/adSlots.js dosyasindadir. Iki dosyadaki
// numaralar ve kategori adlari BIREBIR AYNI olmalidir.
// ============================================================

/** Reklamin hangi panel sayfasindan yonetildigi. */
export const AD_SYSTEM = {
  /** "Reklam Alanlari / Talepler" sayfasi (Advertesing_Form tablosu) */
  FORM: "form",
  /** "Liste Arasi Reklamlar" sayfasi (Advert tablosu) */
  ADVERT: "advert",
};

export const AD_SYSTEM_LABEL = {
  [AD_SYSTEM.FORM]: "Reklam Alanları / Talepler",
  [AD_SYSTEM.ADVERT]: "Liste Arası Reklamlar",
};

/**
 * Uygulamadaki tum reklam alanlari.
 *
 *  no        : Alan numarasi (musteriyle bu numara uzerinden konusulur)
 *  system    : Hangi panel sayfasindan yonetilir
 *  title     : Panelde secilecek kategori adi (veritabanindaki adla BIREBIR ayni)
 *  where     : Kisa konum ("Anasayfa - Is Rehberi kartinin alti")
 *  screens   : Bu numaranin gorundugu TUM ekranlar
 *  format    : Reklamin nasil gosterildigi (sabit / kaydirmali / pano)
 *  status    : "live" = yayinda | "off" = ekran kullanmiyor, reklam gorunmez
 *  note      : Dikkat edilecek nokta (varsa)
 */
export const AD_SLOTS = [
  {
    no: 1,
    system: AD_SYSTEM.ADVERT,
    title: "Anasayfa",
    where: "Anasayfa — hava durumu kartının hemen altındaki reklam panosu",
    screens: ["Anasayfa"],
    format: "Pano (1/2/3 kutucuk, firma adı rozetli)",
    status: "live",
  },
  {
    no: 2,
    system: AD_SYSTEM.FORM,
    title: "BERLİN ESNAF SİTESİ",
    where: "Anasayfa — “Berlin Esnaf Sitesi” kartının altı",
    screens: ["Anasayfa (kart altı)", "Berlin Esnaf Sitesi bölüm ekranı"],
    format: "Kaydırmalı (birden fazla reklam sırayla döner)",
    status: "live",
  },
  {
    no: 3,
    system: AD_SYSTEM.FORM,
    title: "BERLİN İŞ REHBERİ",
    where: "Anasayfa — “Berlin İş Rehberi” kartının altı",
    screens: ["Anasayfa (kart altı)", "Firma Rehberi kategori ekranı"],
    format: "Sabit (kategorideki reklamlar alt alta listelenir)",
    status: "live",
  },
  {
    no: 4,
    system: AD_SYSTEM.FORM,
    title: "BERLİN İLANLAR",
    where: "Anasayfa — “Berlin İlanlar” kartının altı",
    screens: ["Anasayfa (kart altı)", "İlan kategori ekranı"],
    format: "Kaydırmalı (birden fazla reklam sırayla döner)",
    status: "live",
  },
  {
    no: 5,
    system: AD_SYSTEM.FORM,
    title: "MEDYA AKTÜEL",
    where: "Anasayfa — “Medya Aktüel” kartının altı",
    screens: ["Anasayfa (kart altı)", "Hava Durumu ekranı"],
    format: "Sabit (kategorideki reklamlar alt alta listelenir)",
    status: "live",
  },
  {
    no: 6,
    system: AD_SYSTEM.FORM,
    title: "ESNAF AKTÜEL",
    where: "Anasayfa — “Esnaf Aktüel” kartının altı",
    screens: ["Anasayfa (kart altı)", "Esnaf Aktüel bölüm ekranları"],
    format: "Kaydırmalı (birden fazla reklam sırayla döner)",
    status: "live",
  },
  {
    no: 7,
    system: AD_SYSTEM.FORM,
    title: "SÖZ SİZDE",
    where: "Anasayfa — “Söz Sizde” kartının altı",
    screens: ["Anasayfa (kart altı)", "Söz Sizde kategori ekranı"],
    format: "Sabit (kategorideki reklamlar alt alta listelenir)",
    status: "live",
  },
  {
    no: 8,
    system: AD_SYSTEM.FORM,
    title: "Bir Bilen",
    where: "Bir Bilen (forum) kategori ekranı",
    screens: ["Bir Bilen kategori ekranı"],
    format: "Sabit",
    status: "live",
    note:
      "Anasayfadaki “Bir Bilen” kartının altında reklam alanı YOK; bu numaraya " +
      "verilen reklam sadece Bir Bilen ekranında görünür.",
  },
  {
    no: 9,
    system: AD_SYSTEM.FORM,
    title: "NewsCategoryDetail",
    where: "Aktüel haber kategorisi detay ekranı",
    screens: ["Aktüel — haber kategori detay ekranı"],
    format: "Sabit",
    status: "live",
    note: "Kategori adı teknik bir isimdir, değiştirilirse alan boşalır.",
  },
  {
    no: 10,
    system: AD_SYSTEM.FORM,
    title: "HARİTA",
    where: "Harita ekranı",
    screens: ["Harita ekranı"],
    format: "Sabit",
    status: "live",
  },
  {
    no: 11,
    system: AD_SYSTEM.FORM,
    title: "TRAFİK",
    where: "—",
    screens: [],
    format: "—",
    status: "off",
    note:
      "Uygulamada bu numarayı okuyan bir ekran yok. Buraya reklam eklenirse " +
      "hiçbir yerde görünmez.",
  },
  {
    no: 12,
    system: AD_SYSTEM.FORM,
    title: "MÜZİK",
    where: "—",
    screens: [],
    format: "—",
    status: "off",
    note:
      "Uygulamada bu numarayı okuyan bir ekran yok. Buraya reklam eklenirse " +
      "hiçbir yerde görünmez.",
  },
  {
    no: 13,
    system: AD_SYSTEM.ADVERT,
    title: "İlanlar",
    where: "İlan listesinde satır aralarındaki reklam",
    screens: ["İlan liste ekranı"],
    format: "Liste arası",
    status: "live",
  },
  {
    no: 14,
    system: AD_SYSTEM.ADVERT,
    title: "Firma Rehberi",
    where: "Firma rehberi listesinde satır aralarındaki reklam",
    screens: ["Firma rehberi liste ekranı"],
    format: "Liste arası",
    status: "live",
  },
];

/** Turkce karakterleri de dogru kucultup bosluklari sadelestirir. */
const normalize = value =>
  String(value == null ? "" : value)
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("tr-TR");

/**
 * Kategori adindan alan kaydini bulur.
 * @param {string} system AD_SYSTEM.FORM | AD_SYSTEM.ADVERT
 * @param {string} title  Kategori adi
 */
export const findSlot = (system, title) => {
  const key = normalize(title);
  if (!key) return null;
  return (
    AD_SLOTS.find(s => s.system === system && normalize(s.title) === key) || null
  );
};

/** Alan numarasindan kaydi bulur. */
export const findSlotByNo = no =>
  AD_SLOTS.find(s => String(s.no) === String(no)) || null;

/** Tabloda gosterilecek iki haneli numara: 3 -> "03". */
export const slotNoText = no => String(no).padStart(2, "0");

/** Acilir listede gorunecek etiket: "03 · BERLİN İŞ REHBERİ". */
export const slotOptionLabel = (system, title) => {
  const slot = findSlot(system, title);
  return slot ? `${slotNoText(slot.no)} · ${title}` : `— · ${title}`;
};

/** Sadece o panel sayfasina ait alanlar. */
export const slotsOf = system => AD_SLOTS.filter(s => s.system === system);

export default AD_SLOTS;
